import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FOLDER_ACCESS_CONTROL } from '../../Member/MemberBins/actions/FoldersActions';
import ModalDialog from '../../app/Shared/ModalDialog';
import {
  AUDIOBLOCKS,
  GRAPHICSTOCK,
  STORYBLOCKS,
  VIDEOBLOCKS,
} from '../../common/SiteConstants/SiteConstants';
import { getCurrentSite } from '../../common/utils';
import { hidePopUp } from '../actions/PopUpsActions';
import {
  selectPopUpIsOpen,
  selectPopUpsContext,
} from '../selectors/PopUpsSelectors';
import { CREATE_NEW_FOLDER_MODAL } from './types';

const CreateNewFolderModal = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(selectPopUpIsOpen(CREATE_NEW_FOLDER_MODAL));
  const context = useSelector(selectPopUpsContext);

  const [folderName, setFolderName] = useState(context.inputFolderName);
  const [folderAccessControl, setFolderAccessControl] = useState(
    FOLDER_ACCESS_CONTROL.PRIVATE
  );
  const action = context.isCloning ? 'duplicate' : 'create';

  const getPlaceholderText = () => {
    switch (getCurrentSite()) {
      case AUDIOBLOCKS:
        return 'Like "Background Music" or "Nature"';
      case GRAPHICSTOCK:
      case STORYBLOCKS:
        return 'Like "Landscapes" or "Cities"';
      case VIDEOBLOCKS:
        return 'Like "Landscapes" or "Cities"';
    }
  };

  const handleClose = () => {
    dispatch(hidePopUp());
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    context.buttonAction(folderName, folderAccessControl);
    handleClose();
  };

  return (
    <ModalDialog
      isOpen={isOpen}
      className="text-center max-w-xl"
      contentLabel={context.title || ''}
      onRequestClose={handleClose}
    >
      <form onSubmit={handleSubmit}>
        <div className="createNewFolderModal">
          {context.isInSharedFoldersBeta && (
            <div className="text-left p-2 pt-0">
              <h1 className="m-0 text-base">What would you like to do?</h1>
              <div className="createNewFolderModal-radioContainer">
                <label className="flex items-center font-normal">
                  <input
                    type="radio"
                    className="h-10 w-8 border border-solid border-old-silver rounded-sm bg-white mr-2"
                    value="private"
                    checked={
                      folderAccessControl === FOLDER_ACCESS_CONTROL.PRIVATE
                    }
                    onChange={(event) =>
                      setFolderAccessControl(event.target.value)
                    }
                  />
                  I'd like to {action} a private folder.
                </label>
              </div>
              <div className="createNewFolderModal-radioContainer">
                <label className="flex items-center font-normal">
                  <input
                    type="radio"
                    className="h-10 w-8 border border-solid border-old-silver rounded-sm bg-white mr-2"
                    value={FOLDER_ACCESS_CONTROL.SHARED}
                    checked={
                      folderAccessControl === FOLDER_ACCESS_CONTROL.SHARED
                    }
                    onChange={(event) =>
                      setFolderAccessControl(event.target.value)
                    }
                  />
                  I'd like to {action} a folder that my entire organization can
                  see.
                </label>
              </div>
            </div>
          )}
          <label className="text-left">
            Folder Name
            <br />
            <input
              id="folder-name"
              className="h-10 w-80 border border-solid border-old-silver rounded-sm bg-white mb-6 pl-1"
              onChange={(event) => setFolderName(event.target.value)}
              placeholder={getPlaceholderText()}
              type="text"
              value={folderName}
              aria-label="Folder name"
            />
          </label>
          <br />
          <button
            type="submit"
            className="btn btn-primary font-bold"
            disabled={!folderName}
          >
            {context.buttonText}
          </button>
        </div>
      </form>
    </ModalDialog>
  );
};

export default CreateNewFolderModal;
